import React, { useEffect } from "react";
import Logo from "../../assets/images/Logo.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getNotificationCountsHandler } from "../../redux/action/getNotificationsCounts";
import { useTranslation } from "react-i18next";
import { getItem, setItem } from "../../common/localStorage";

const MobileSidebar = ({ mobileSidebar, setMobileSidebar }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { t } = useTranslation();
  const getAdminId = getItem("adminId");

  const getNotificationsCountsSelector = useSelector(
    (state) => state?.getNotificationsCounts
  );

  const getAllProductListSelector = useSelector(
    (state) => state?.getProductList
  );

  // useEffect(() => {
  //   if (getNotificationsCountsSelector?.data?.data?.userAgreement === false) {
  //     navigate("/consent");
  //   }
  // }, [getNotificationsCountsSelector, navigate]);

  useEffect(() => {
    dispatch(getNotificationCountsHandler({ userId: getAdminId ?? 0 }));
  }, [getAdminId, dispatch]);

  return (
    <>
      <div
        className={`mobileSidebar mobileShow  ${
          mobileSidebar === true ? "appear" : ""
        }`}
      >
        <div className="mx-280">
          <div className="headerLogoImage">
            <img src={Logo} alt="" />
          </div>
          <div className="p-20">
            <div className="gb fw-600 mb-20 fs-18">{t("My Products")}</div>
            {getAllProductListSelector?.data?.data?.products?.map(
              (item, index) => {
                return (
                  <h3
                    className={`productList cursor-pointer ${
                      getItem("productName") === item?.productName ||
                      (!getItem("productName") &&
                        getAllProductListSelector?.data?.data?.products?.[0]
                          ?.productName === item?.productName)
                        ? "activated"
                        : ""
                    }`}
                    // onClick={productOpen}
                    onClick={() => {
                      navigate("/dashboard", { state: item });
                      // setActiveProductName(item?.productName);
                      setItem("groupId", item?.groupId);
                      setItem("productCode", item?.productCode);
                      setItem("productName", item?.productName);
                      setMobileSidebar(false);
                    }}
                    key={index}
                  >
                    {item?.productName}
                  </h3>
                );
              }
            )}
          </div>
        </div>
      </div>
      {mobileSidebar === true ? (
        <>
          <div
            className="mobileOverlay mobileShow cursor-pointer"
            onClick={() => setMobileSidebar(false)}
          ></div>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default MobileSidebar;
